import gql from 'graphql-tag';

export const UPDATE_USER = gql`
mutation updateUser($data : UserUpdateInput!, $phone: String){
  updateUser(data: $data, where: { phone: $phone }){
    firstName
  }
} `;